import { datadogRum } from '@datadog/browser-rum';

let isInitialized = false;

export function initDatadogRum(): void {
  if (isInitialized) return;

  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';

  if (['staging', 'production'].includes(environment)) {
    const sessionSampleRate = Number(process.env.REACT_APP_DATADOG_RUM_SAMPLE_RATE ?? 100);
    const sessionReplaySampleRate = Number(process.env.REACT_APP_DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE ?? 20);

    datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_RUM_APP_ID ?? '',
      clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN ?? '',
      site: 'datadoghq.com',
      service: 'qr-ordering',
      env: environment,
      version: '1.0.0',
      sessionSampleRate,
      sessionReplaySampleRate,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      startSessionReplayRecordingManually: false,
    });
  }

  isInitialized = true;
}
